import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import heroImage from '../assets/main1.png';
import resamLogo from '../assets/resam.png';

export default function QuiSommesNousPage() {
  // 1. État pour le tracking du scroll (Parallaxe)
  const [offsetY, setOffsetY] = useState(0);

  // 2. Écouteur de scroll pour la parallaxe
  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const team = [
    { name:'Florent D.', role:'Fondateur & directeur', emoji:'👤' },
    { name:'Équipe RÉSAM', role:'Réseau national', emoji:'🌿' },
  ];
  
  const values = [
    { icon:'🪢', title:'Réseau', desc:'Renforcer les coopérations sur votre territoire' },
    { icon:'✊', title:"Pouvoir d'agir", desc:'Favoriser l’engagement citoyen' },
    { icon:'🧠', title:'Innovation sociale', desc:'Transformer en profondeur les dynamiques sociales' },
  ];

  // Configurations d'animation pour Framer Motion
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15 } // Fait apparaître les cartes une par une
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    show: { 
      opacity: 1, 
      y: 0, 
      transition: { type: "spring", stiffness: 80, damping: 15 } 
    }
  };

  return (
    <div style={{ paddingTop:'var(--nav-h, 64px)', overflow:'hidden' }}>
      
      {/* STYLE POUR LA PARALLAXE RESPONSIVE */}
      <style>{`
        .qsn-parallax-img {
          position: absolute;
          top: 5%;
          right: 5%;
          width: 450px;
          pointer-events: none;
          z-index: 0;
          opacity: 0.35;
          filter: contrast(0.9) brightness(1.2);
          transition: transform 0.1s ease-out;
        }

        .qsn-text-container {
          max-width: 1100px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .qsn-parallax-img {
            width: 150%;
            right: -25%;
            top: 15%;
            opacity: 0.1;
          }
          .qsn-text-container {
            background: radial-gradient(circle, rgba(26,10,0,0.85) 0%, rgba(26,10,0,0) 70%);
            padding: 20px 0;
          }
        }
      `}</style>

      {/* Hero */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'#1A0A00', color:'#fff', position:'relative', overflow:'hidden' }}>
        
        {/* Cercles décoratifs */}
        <div style={{ position:'absolute', top:'50%', right:'-8%', width:'40vw', height:'40vw', border:'1px solid rgba(217,79,0,.2)', borderRadius:'50%', transform:'translateY(-50%)', pointerEvents:'none', zIndex: 0 }} />
        
        {/* IMAGE PARALLAXE RESPONSIVE */}
        <img 
          src={heroImage}
          alt="Floating visual"
          className="qsn-parallax-img"
          style={{ transform: `translateY(${offsetY * 0.4}px)` }}
        />

        {/* CONTENEUR TEXTE PROTÉGÉ */}
        <div className="qsn-text-container">
          <p style={{ fontFamily:'Space Mono,monospace', fontSize:10, color:'rgba(217,79,0,.8)', letterSpacing:'.14em', textTransform:'uppercase', marginBottom:20 }}>À propos</p>
          <h1 style={{ fontSize:'clamp(36px,5.5vw,68px)', fontWeight:700, letterSpacing:'-.03em', lineHeight:1.05, marginBottom:40, maxWidth:640 }}>
            Qui sommes-nous ?
          </h1>
          
          {/* Texte espacé pour plus de lisibilité */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18, marginBottom: 48 }}>
            <p style={{ fontSize:18, color:'rgba(255,255,255,.85)', maxWidth:600, lineHeight:1.7 }}>
              RADAR a été créé en co-construction par un réseau d'acteurs du territoire du Pays de Morlaix piloté par le Résam. 
            </p>
            <p style={{ fontSize:18, color:'rgba(255,255,255,.65)', maxWidth:600, lineHeight:1.7 }}>
              Le Résam accompagne la vie associative du Pays de Morlaix et porte des projets d'innovation sociale. Son rôle est de soutenir, d’accompagner et de valoriser les associations pour construire les conditions les plus efficientes à la mise en œuvre de leurs projets.
            </p>
            <p style={{ fontSize:18, color:'rgba(255,255,255,.65)', maxWidth:600, lineHeight:1.7 }}>
              Il est un lieu de conseil et de diffusion d’informations. Il favorise la mutualisation des moyens, des connaissances et entretient le lien entre les associations du territoire.
            </p>
            <p style={{ fontSize:18, color:'rgba(255,255,255,.85)', maxWidth:600, lineHeight:1.7, fontWeight: 500 }}>
              Avec RADAR, le Résam propose un outil clé-en-main pour favoriser les animations et les coopérations sur vos territoires. 
            </p>
          </div>

          {/* Logo cliquable */}
          {/* Logo cliquable (sans fond, sans texte, sans cadre) */}
          <a 
            href="https://www.resam.net/" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              display: 'inline-block',
              transition: 'opacity 0.2s ease' 
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            <img 
              src={resamLogo} 
              alt="Site du Résam" 
              style={{ 
                height: 60, // Vous pouvez modifier cette valeur pour agrandir/rétrécir le logo
                display: 'block' 
              }} 
            />
          </a>

        </div>
      </section>

      {/* Values - AVEC ANIMATIONS FRAMER MOTION */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'var(--radar-cream)' }}>
        <div style={{ maxWidth:1100, margin:'0 auto' }}>
          <p className="section-label" style={{ marginBottom:16 }}>Nos valeurs</p>
          <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:48 }}>3 piliers qui guident RADAR</h2>
          
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:24 }}
          >
            {values.map((v,i) => (
              <motion.div 
                key={i} 
                variants={itemVariants}
                whileHover={{ y: -8, scale: 1.02, boxShadow: '0 16px 40px rgba(0,0,0,0.08)' }}
                style={{ background:'#fff', border:'1px solid rgba(122,140,136,.18)', borderRadius:8, padding:'28px 24px', cursor: 'default', transition: 'box-shadow 0.3s ease' }}
              >
                <div style={{ fontSize:36, marginBottom:14 }}>{v.icon}</div>
                <h3 style={{ fontSize:18, fontWeight:700, marginBottom:10, color:'var(--radar-dark)' }}>{v.title}</h3>
                <p style={{ fontSize:14, color:'#5A6B68', lineHeight:1.65 }}>{v.desc}</p>
              </motion.div>
            ))}
          </motion.div>
          
        </div>
      </section>

      {/* Contact CTA */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'#fff' }}>
        <div style={{ maxWidth:700, margin:'0 auto', textAlign:'center' }}>
          <h2 style={{ fontSize:30, fontWeight:700, marginBottom:14 }}>Vous souhaitez nous rejoindre ?</h2>
          <p style={{ color:'#5A6B68', fontSize:16, marginBottom:40, lineHeight:1.6 }}>
            Que vous soyez organisateur, partenaire ou simple curieux, nous serons ravis d'échanger avec vous.
          </p>
          
          <div style={{ marginBottom: 56 }}>
            <Link to="/LancerVotreRadar" className="btn-primary" style={{ fontSize: 16, padding: '14px 32px' }}>Lancer votre RADAR →</Link>
          </div>

          {/* Nouvelle carte de contact UI */}
          <div style={{ 
            background: 'var(--radar-cream)', 
            border: '1px solid rgba(122,140,136,.15)', 
            borderRadius: 16, 
            padding: '36px', 
            display: 'inline-flex', 
            flexDirection: 'column', 
            alignItems: 'flex-start', 
            textAlign: 'left', 
            boxShadow: '0 12px 30px rgba(0,0,0,0.03)', 
            maxWidth: '100%', 
            width: '380px' 
          }}>
            <h3 style={{ 
              fontSize: 20, 
              fontWeight: 700, 
              color: 'var(--radar-dark)', 
              marginBottom: 24, 
              borderBottom: '2px solid rgba(217,79,0,.15)', 
              paddingBottom: 12, 
              width: '100%' 
            }}>
              Contact du Résam
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18, color: '#5A6B68', fontSize: 15, lineHeight: 1.5 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                <span style={{ fontSize: 22, lineHeight: 1.2 }}>📍</span>
                <span>2D, voie d'accès au port<br/>29600 MORLAIX</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ fontSize: 22 }}>📞</span>
                <a href="tel:+33298637191" style={{ color: '#5A6B68', textDecoration: 'none', fontWeight: 500 }}>
                  02 98 63 71 91
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ fontSize: 22 }}>✉️</span>
                <a href="mailto:animation@resam.net" style={{ color: 'var(--radar-deep)', fontWeight: 600, textDecoration: 'none' }}>
                  animation@resam.net
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}